// src/components/Reports/Ledger.tsx
import React, { useEffect } from "react";
import { useRecentInvoiceAndReturns } from "../../../hooks/useRecentInvoiceAndReturns";
import { InvoiceAndReturnsTable } from "./InvoiceAndReturnsTable";

interface RecentInvoiceAndReturnsProps {
	lastDays: number;
	maskProfit?: boolean;
}

export const RecentInvoiceAndReturns = (
	props: RecentInvoiceAndReturnsProps
) => {
	const { ledgerEntries, loading, fetchLedgerData } =
		useRecentInvoiceAndReturns();

	useEffect(() => {
		const endDate = new Date();
		const startDate = new Date();
		startDate.setDate(endDate.getDate() - props.lastDays);

		const formattedStartDate = startDate.toLocaleDateString("en-CA");
		const formattedEndDate = endDate.toLocaleDateString("en-CA");
		fetchLedgerData(formattedStartDate, formattedEndDate);
	}, [props.lastDays, fetchLedgerData]);

	if (loading) return <p>Searching ledger...</p>;

	return (
		<>
			<InvoiceAndReturnsTable
				ledgerEntries={ledgerEntries}
				maskProfit={props.maskProfit}
			/>
		</>
	);
};
